/**
 * @file SharePoint User Group Request Controller component
 * Inline justification form for SharePoint group requests
 * @version 1.0.0
 * @since 2025-09-05
 */

export default {
  name: 'SharePointUserGroupRequestController',

  props: {
    groupState: String,
    group: Object,
    user: Object,
    pendingRequest: Object,
    groupId: String,
  },

  emits: ['join', 'leave', 'cancel'],

  data() {
    return {
      showForm: false,
      action: null,
      justification: '',
    };
  },

  methods: {
    startJoin() {
      this.action = 'join';
      this.showForm = true;
      this.justification = '';
    },

    startLeave() {
      this.action = 'leave';
      this.showForm = true;
      this.justification = '';
    },

    submit() {
      this.$emit(this.action, { justification: this.justification.trim() });
      this.showForm = false;
    },

    cancel() {
      this.showForm = false;
    },

    cancelRequest() {
      this.$emit('cancel');
    },
  },

  template: `
    <div class="text-end">
      <!-- Normal buttons -->
      <div v-if="!showForm">
        <span v-if="groupState === 'member'" class="badge bg-success mb-2">
          <i class="bi bi-check-circle"></i> Member
        </span>
        <span v-else-if="groupState === 'pending'" class="badge bg-warning mb-2">
          <i class="bi bi-clock"></i> Pending
        </span>

        <div>
          <button v-if="groupState === 'member'" 
                  class="btn btn-sm btn-outline-danger" 
                  @click="startLeave">
            Leave
          </button>
          <button v-else-if="groupState === 'pending'" 
                  class="btn btn-sm btn-outline-secondary" 
                  @click="cancelRequest">
            Cancel
          </button>
          <button v-else 
                  class="btn btn-sm btn-outline-primary" 
                  @click="startJoin">
            Join Group
          </button>
        </div>
      </div>

      <!-- Justification form -->
      <div v-else class="mt-2">
        <small class="text-muted d-block mb-1">{{ action === 'join' ? 'Join' : 'Leave' }} {{ group.name || groupId }}</small>
        <textarea v-model="justification" 
                  class="form-control form-control-sm mb-2" 
                  rows="2" 
                  :placeholder="'Why do you want to ' + action + ' this group?'"
                  style="font-size: 0.875rem;">
        </textarea>
        <div class="d-flex gap-1">
          <button class="btn btn-sm btn-secondary" @click="cancel" style="font-size: 0.75rem;">Cancel</button>
          <button class="btn btn-sm btn-primary" @click="submit" style="font-size: 0.75rem;">Submit</button>
        </div>
      </div>
    </div>
  `,
};
